import React, { useState } from 'react';
import {
  Paper,
  Typography,
  Avatar,
  Button,
  Divider,
  Box,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { 
  FaEnvelope, 
  FaUserTag, 
  FaBuilding, 
  FaKey, 
  FaEdit,
  FaCheckCircle
} from 'react-icons/fa';
import { auth } from '../../firebaseConfig';
import { sendPasswordResetEmail } from 'firebase/auth';
import './PersonalProfile.css';

const PersonalProfile = ({ currentUser, userRole }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [showPasswordDialog, setShowPasswordDialog] = useState(false);
  const [passwordResetSent, setPasswordResetSent] = useState(false);
  const [userInfo, setUserInfo] = useState({
    displayName: currentUser?.displayName || '',
    email: currentUser?.email || '',
    role: userRole || '',
    enterprise: 'CycleIT'
  });

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleSave = () => {
    // Here you would typically save the changes to your backend
    setIsEditing(false);
  };

  const handlePasswordReset = async () => {
    try {
      await sendPasswordResetEmail(auth, currentUser.email);
      setPasswordResetSent(true);
      setTimeout(() => {
        setShowPasswordDialog(false);
        setPasswordResetSent(false);
      }, 3000);
    } catch (error) {
      console.error('Error sending password reset email:', error);
    }
  };

  const InfoRow = ({ icon: Icon, label, value, editable }) => (
    <div className="info-row">
      <Icon className="info-icon" />
      <div className="info-content">
        <Typography variant="caption" className="info-label">
          {label}
        </Typography>
        <Typography variant="body1" className="info-value">
          {value}
        </Typography>
      </div>
    </div>
  );

  return (
    <div className="personal-profile-container">
      <Paper elevation={3} className="profile-paper">
        <div className="profile-header">
          <Avatar
            src={currentUser?.photoURL}
            alt={userInfo.displayName}
            className="profile-avatar"
          />
          <div className="profile-title">
            <Typography variant="h5" className="profile-name">
              {userInfo.displayName}
            </Typography>
            <Typography variant="subtitle2" className="profile-subtitle">
              Personal Information
            </Typography>
          </div>
          <Button
            variant="outlined"
            color="primary"
            className="edit-button"
            onClick={isEditing ? handleSave : handleEdit}
            startIcon={isEditing ? <FaCheckCircle /> : <FaEdit />}
            style={{ visibility: 'hidden' }}
          >
            {isEditing ? 'Save' : 'Edit'}
          </Button>
        </div>

        <Divider className="profile-divider" />

        <Box className="profile-info-section">
          <InfoRow
            icon={FaEnvelope}
            label="Email"
            value={userInfo.email}
            editable={false}
          />
          <InfoRow
            icon={FaUserTag}
            label="Role"
            value={userInfo.role}
            editable={false}
          />
          <InfoRow
            icon={FaBuilding}
            label="Company"
            value={userInfo.enterprise}
            editable={false}
          />
        </Box>

        <Divider className="profile-divider" />

        <Box className="profile-actions">
          <Button
            variant="outlined"
            color="primary"
            startIcon={<FaKey />}
            onClick={() => setShowPasswordDialog(true)}
            className="password-reset-button"
          >
            Reset Password
          </Button>
        </Box>
      </Paper>

      {/* Password Reset Dialog */}
      <Dialog
        open={showPasswordDialog}
        onClose={() => setShowPasswordDialog(false)}
        className="password-dialog"
      >
        <DialogTitle>
          {passwordResetSent ? "Email Sent!" : "Reset Password"}
        </DialogTitle>
        <DialogContent>
          {passwordResetSent ? (
            <Typography>
              A password reset link has been sent to your email address.
            </Typography>
          ) : (
            <Typography>
              Are you sure you want to reset your password? A reset link will be sent to your email address.
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          {!passwordResetSent && (
            <>
              <Button onClick={() => setShowPasswordDialog(false)}>
                Cancel
              </Button>
              <Button onClick={handlePasswordReset} color="primary">
                Send Reset Link
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default PersonalProfile; 